import { useState } from "react";

import { Row } from "@tanstack/table-core";

import { ProjectIssuesTable } from "@/features/project-management/hooks/use-project-issues-table";
import {
  ColumnId,
  ProjectIssueWithChildren,
} from "@/features/project-management/types";
import { IssueType } from "@/generated/graphql";

import { FilterCombobox } from "../../filter-combobox";
import { SearchMultiSelectItem } from "../../filter-combobox/filter-combobox";

export const IssueMilestoneFilter = ({
  table,
}: {
  table: ProjectIssuesTable;
}) => {
  const column = table.getColumn(ColumnId.Title)!;
  const committed = (column.getFilterValue() ?? []) as string[];

  const items = table
    .getCoreRowModel()
    .rows.filter(
      (row: Row<ProjectIssueWithChildren>) =>
        row.original.type === IssueType.Milestone
    )
    .map(
      (row: Row<ProjectIssueWithChildren>): SearchMultiSelectItem => ({
        value: row.original.title,
        label: row.original.title,
      })
    );

  const [selected, setSelected] = useState<string[]>(committed);

  const handleApply = () => {
    column.setFilterValue(selected);
  };

  const handleClear = () => {
    column.setFilterValue([]);
    setSelected([]);
  };

  return (
    <FilterCombobox
      items={items}
      title="Milestone"
      isSearchable={false}
      selectedItemIds={selected}
      onSelectedChange={setSelected}
      onApply={handleApply}
      onClear={handleClear}
      withAvatar={false}
      withIcon={false}
    />
  );
};
